import React from 'react';
import { motion } from 'framer-motion';
import '../styles/FilmCard.css';


const FilmCard = ({ film }) => {
  return (
    <motion.div
      className="film-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <img src={film.poster} alt={film.titre} />
      <h2>{film.titre}</h2>
      <p><strong>Réalisateur :</strong> {film.realisateur}</p>
      <p><strong>Année :</strong> {film.annee}</p>
    </motion.div>
  );
};


export default FilmCard;